export default {
  'footer:social-title': 'Keine News & Aktionen mehr verpassen!',
  'footer:newsletter-title':
    'Melde dich für unseren Newsletter an und sicher dir einen 15% Gutschein.',
  'footer:newsletter-input-placeholder': 'Deine E-Mail-Adresse',
  'footer:newsletter-button-cat': 'Katzenfan',
  'footer:newsletter-button-dog': 'Hundefan',
  'footer:newsletter-unsubscribe-notice':
    'Gutschein nur für deine erste Bestellung gültig. {br} Mit deiner Anmeldung stimmst du unseren <a>Datenschutzbedingungen</a> zu. {br} <strong>Du kannst dich jederzeit wieder abmelden.</strong>',
  'footer:newsletter-main-title': 'Newsletter',
  'footer:newsletter-petsdeli-hashtag': '#petsdelifamily',
  'footer:social-facebook': 'Facebook',
  'footer:social-instagram': 'Instagram',
  'footer:social-ambassador-program': 'Markenbotschafter*in werden',

  'footer:title-valuable': 'Gut zu wissen',
  'footer:title-good-for-you': 'Goodies für dich',
  'footer:title-help': 'Hilfe',
  'footer:title-shipping': 'Zuverlässige Lieferung mit',
  'footer:title-payment': 'Bezahle mit',
  'footer:title-legal': 'Pets Deli',
  'footer:help-title': 'Fragen? Immer her damit! Wir helfen dir und deinem Liebling gerne weiter.',
  'footer:newsletter-thank-you':
    'Danke für deine Anmeldung! {br} Wir haben dir eine Bestätigungsmail gesendet.',
  'footer:refer-friend:title': '{amount} für dich, {amountFriend} für deine*n Freund*in',
  'footer:refer-friend:subtitle': 'so funktioniert es',

  'footer:refer-friend:steps:copy-link': 'Teil Pets Deli mit deinen Freund*innen',
  'footer:refer-friend:steps:share-with-friend':
    'Dein*e Freund*in erhält automatisch {amountFriend} Rabatt beim ersten Einkauf',
  'footer:refer-friend:steps:result':
    'Du erhältst dein {amount}-Guthaben, sobald dein*e Freund*in bestellt hat.',

  'footer:link-section:opening-hours': 'Mo-Fr, 9-18 Uhr',
  'footer:link-section:link-help': 'Du benötigst Hilfe?',
  'footer:link-section:customer-support-phone-number': '{phone}',
  'footer:link-section:whatsapp-number': '{whatsapp}',
  'footer:link-section:language-switcher': 'Sprache wählen',
  'footer:link-section:widerruf-button': 'Vertrag widerrufen',
  'footer:link-section:widerruf-aria': 'Vertrag widerrufen – Widerrufsformular öffnen',
};
